import classNames from "classnames"
import { ChangeEvent, useState } from "react"
import { useController } from "react-hook-form"
import { FieldProps } from "../../types/FieldProps"
import { TextAreaProps } from "../../types/TextAreaProps"
import { FormErrorText } from "../FormErrorText"
import { FormHelperText } from "../FormHelperText"
import { FormLabel } from "../FormLabel"

interface Props extends FieldProps {
  textAreaProps?: TextAreaProps
  className?: string
  maximumCharacters?: number
}

export function TextArea(props: Props) {
  const {
    field,
    fieldState: { error },
  } = useController(props)

  const initialCount = field.value?.length ?? 0

  const [characterCount, setCharacterCount] = useState(initialCount)

  const {
    label,
    name,
    textAreaProps,
    helperText,
    className,
    placeholder,
    maximumCharacters,
    optional,
  } = props

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const userInput = e.target.value
    setCharacterCount(userInput.length)
    field.onChange(e)
  }

  return (
    <div className={classNames("flex flex-col", className)}>
      <div className="pb-[var(--alias-padding-xxs)] mr-auto">
        <FormLabel className="pb-[var(--alias-padding-xxs)]" htmlFor={name}>
          {label || name}
          {!optional && <span className="text-red-500">*</span>}
        </FormLabel>
      </div>
      <textarea
        placeholder={placeholder}
        className={classNames("form-field resize-none min-h-[6.5rem]", {
          "form-field error": error,
        })}
        id={name}
        {...field}
        onChange={handleChange}
        {...textAreaProps}
      />
      {maximumCharacters ? (
        <p
          className={classNames("mt-1 ml-auto", {
            "text-[color:var(--alias-color-text-critical)]":
              characterCount >= maximumCharacters,
          })}
        >
          {characterCount}/{maximumCharacters}
        </p>
      ) : null}
      {helperText?.length ? (
        <FormHelperText>{helperText}</FormHelperText>
      ) : null}
      {error && (
        <FormErrorText className="pt-[var(--alias-padding-xxs)]">
          {error?.message}
        </FormErrorText>
      )}
    </div>
  )
}
